import * as Yup from 'yup';

// Step 1 Validation //
export const VALIDATION_STEP_1 = Yup.object({
  firstName: Yup.string().required('This field is required'),
  lastName: Yup.string().required('This field is required'),
});

// Step 2 Validation //
export const VALIDATION_STEP_2 = Yup.object({
  phone: Yup.string().required('This field is required'),
});

// Step 3 Validation //
export const VALIDATION_STEP_3 = Yup.object({
  email: Yup.string()
    .email('Invalid Email format')
    .required('This field is required'),
});

// Step 4 Validation //
export const VALIDATION_STEP_4 = Yup.object({
  address: Yup.string().required('This field is required'),
});

// Step 5 Validation //
export const VALIDATION_STEP_5 = Yup.object({
  altStreet: Yup.string(),
});

// Step 8 Validation //
export const VALIDATION_STEP_8 = Yup.object({
  comment: Yup.string(),
});
